import { Component } from '@angular/core';

@Component({
	templateUrl: './flexbox.component.html',
	styleUrls: ['./flexbox.scss'],
})
export class FlexboxComponent {}
